import { useEffect, useRef, useState } from "react";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import MediaQueryTool from "../utils/MediaQueryTool";
import home from "../assets/home.svg";
import gallery from "../assets/gallery.svg";
import contactUs from "../assets/contact-us.svg";

const Header = () => {
  const mediaQueryTools = MediaQueryTool();

  const unselectableTextStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
  };

  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (
      navRef.current &&
      !navRef.current.contains(event.target) &&
      toggleButtonRef.current &&
      !toggleButtonRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setIsVisible(currentScrollPos < 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      {isVisible && (
        <Navbar
          expand="lg"
          style={{
            ...unselectableTextStyle,
            position: "fixed",
            top: 0,
            zIndex: 100,
            width: "100%",
            backgroundColor: "rgba(3,55,99,0)",
          }}
        >
          <Container>
            <Navbar.Brand href="/" style={{ color: "cyan" }}>
              Sugarno
            </Navbar.Brand>
            {mediaQueryTools.isXS && (
              <Navbar.Toggle
                ref={toggleButtonRef}
                onClick={toggleNav}
                style={{ backgroundColor: "cyan" }}
              />
            )}

            {!mediaQueryTools.isXS && (
              <Navbar>
                <Nav style={{ gap: 30, fontSize: 20 }}>
                  <Nav.Link href="/" style={{ color: "cyan" }}>
                    Home
                  </Nav.Link>
                  <Nav.Link href="/gallery" style={{ color: "cyan" }}>
                    Gallery
                  </Nav.Link>
                  <Nav.Link href="/contactus" style={{ color: "cyan" }}>
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar>
            )}
          </Container>
        </Navbar>
      )}

      <div
        ref={navRef}
        style={{
          position: "fixed",
          top: 0,
          left: isOpen ? 0 : "-250px",
          height: "100%",
          width: "200px",
          backgroundColor: "black",
          color: "white",
          transition: "left 0.3s ease",
          zIndex: 1000,
          padding: "20px",
        }}
      >
        <button
          onClick={toggleNav}
          style={{
            position: "absolute",
            top: "10px",
            right: "8px",
            border: "none",
            cursor: "pointer",
            color: "red",
            padding: "10px 20px",
            fontSize: 20,
            backgroundColor: "transparent",
          }}
        >
          X
        </button>
        <nav style={{ marginTop: "45px" }}>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            <a className="nav-link" href="/">
              <li
                className="nav-item"
                style={{ display: "flex", alignItems: "center", gap: 15 }}
              >
                <Image height={20} width={20} src={home} />
                <label className="nav-label">Home</label>
              </li>
            </a>
            <a className="nav-link" href="/gallery">
              <li
                className="nav-item"
                style={{ display: "flex", alignItems: "center", gap: 15 }}
              >
                <Image height={20} width={20} src={gallery} />

                <label className="nav-label">Gallery</label>
              </li>
            </a>
            <a className="nav-link" href="/contactus">
              <li
                className="nav-item"
                style={{ display: "flex", alignItems: "center", gap: 15 }}
              >
                <Image height={20} width={20} src={contactUs} />
                <label className="nav-label">Contact Us</label>
              </li>
            </a>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
